export const ChatHeader = ({ className }: { className?: string }) => {
  return <div className={className}>
    AI 助理
  </div>
}

export default ChatHeader